import { relationship, relationshipToColor } from '../../../consts'
import $t from '../../../i18n'

import './RelationTag.css'

const RelationTag = ({ relation, count }) => {
  return (
    <div
      className='relation-tag semi-bold'
      style={{
        background:
          relation === relationship.owner
            ? relationshipToColor.owner
            : relationshipToColor[relation]
      }}
    >
      {relation === relationship.owner
        ? $t('common.myself')
        : $t(count ? `common.${relation} ${count}` : `common.${relation}`)}
    </div>
  )
}
export default RelationTag
